import React from 'react'
import SubHeader from '../../layout/components/SubHeader'
import {toAbsoluteUrl} from '../../helpers/AssetHelpers'
import TabCard from './clinicsettings/TabCard'
import ModernTabs from '../../common/Tabs/ModernTabs'


function ClinicSettings() {

  return (
   <>
    <SubHeader title="Clinic Settings" description={"Clinic related settings."}/>
       <TabCard/>

   </>
  )
}

export default ClinicSettings